import { useEffect, useState } from 'react'
import { Select } from './Select'
import { Input } from './Input'

import { salary } from '../../i18n/translatedMessages'
import { FormattedMessage } from 'react-intl'

export function FilterBar({ lists, filtered, setFiltered }) {
	const [filters, setFilters] = useState(null)
	const [nameFilter, setNameFilter] = useState('')

	const handleFilterName = event => {
		setNameFilter(event.target.value)
	}

	const handleFilter = event => {
		setFilters({
			...filters,
			[event.target.name]: event.target.value,
		})
	}

	useEffect(() => {
		let aux = [...lists.employees]

		if (filters) {
			Object.keys(filters).forEach(key => {
				if (filters[key]) {
					aux = lists.employees.filter(item => item[key]?.id === filters[key])
				}
			})
		}

		if (nameFilter !== '') {
			aux = aux.filter(item => item.name.includes(nameFilter))
		}

		setFiltered(aux)
	}, [nameFilter, filters, lists])

	const handleClearFilter = () => {
		setFilters(null)
		setNameFilter('')
		setFiltered(lists.employees)
	}

	return (
		<div className='tw-mb-2 tw-flex tw-items-center tw-gap-2 tw-w-full'>
			<FormattedMessage id='inputPlaceholderName'>{msg => <Input onChange={handleFilterName} value={nameFilter} placeholder={msg} />}</FormattedMessage>
			<Select placeholder={salary.inputPlaceholderSelectCountry} list={lists.countries} onChange={handleFilter} name='country' value={filters?.country} />
			<Select placeholder={salary.inputPlaceholderSelectArea} list={lists.areas} onChange={handleFilter} name='area' value={filters?.area} />
			<Select placeholder={salary.inputPlaceholderSelectLevels} list={lists.levels} onChange={handleFilter} name='level' value={filters?.level} />
			<button className='border tw-bg-white tw-rounded-md tw-p-2 tw-h-full tw-w-full tw-max-w-[200px]' onClick={handleClearFilter}>
				{salary.btnClearFilter}
			</button>
		</div>
	)
}
